import baseApi from '../baseApi';
import { FranchiseOtherDetailsPIM } from '../../Interfaces/PIMs/Franchise/FranchiseOtherDetails';
import { SD_SPNameList } from '../../Utility/StaticDatas';

const baseUrl = `/AuthDataGet/ExecuteJson/${SD_SPNameList.DB_SP_FranchiseOtherDetails}`;

const SPFranchiseOtherDetailsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    upsertFranchiseLogo: builder.mutation({
      query: (data: FranchiseOtherDetailsPIM) => ({
        url: `${baseUrl}/1`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['FranchiseOtherDetails'],
    }),
    getFranchiseOtherDetails: builder.query({
      query: (data: FranchiseOtherDetailsPIM) => ({
        url: `${baseUrl}/2`,
        method: 'POST',
        body: data,
      }),
      providesTags: ['FranchiseOtherDetails'],
    }),
    franchiseBasicDetails: builder.query({
      query: () => ({
        url: `${baseUrl}/3`,
        method: 'POST',
        body: {},
      }),
      providesTags: ['FranchiseOtherDetails'],
    }),
    franchiseAutoEmailAndPlayerCreate: builder.mutation({
      query: () => ({
        url: `${baseUrl}/4`,
        method: 'POST',
        body: {},
      }),
      invalidatesTags: ['FranchiseOtherDetails'],
    })
  }),
});

export const {
  useUpsertFranchiseLogoMutation,
  useGetFranchiseOtherDetailsQuery,
  useFranchiseBasicDetailsQuery,
  useFranchiseAutoEmailAndPlayerCreateMutation,
} = SPFranchiseOtherDetailsApi;

export default SPFranchiseOtherDetailsApi;
